import styled from "@emotion/styled"
import { Button, Menu, MenuItem, Typography } from "@mui/material"
import { useState } from "react"
import { Link, webMenuClick } from "utils"

import { getNonUmbracoUrl } from "utils"
import ArrowDown from "../../icons/ArrowDown"
import ArrowUp from "../../icons/ArrowUp"
import { sharedColors } from "../../theme/colors"
import { MenuItemData } from "./Header"

const MenuButton = styled(Button)`
  background-color: transparent;
  padding: 0;
  margin: 0;
  min-width: 0;
  /* height: 40px; */
  height: 100%;
  border-radius: 0;

  & .MuiTypography-root::before {
    display: block;
    content: attr(data-content);
    font-weight: 500;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`

const ButtonInner = styled.div<{ isOpen: boolean }>`
  height: 40px;
  display: flex;
  ${({ isOpen }) =>
    isOpen && `box-shadow: inset 0 -2px 0 ${sharedColors.brandDark};`}
  :hover {
    box-shadow: inset 0 -2px 0 ${sharedColors.brandDark};
  }
  align-items: center;
  gap: 4px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  width: 100%;
  padding: 16px;
  color: ${sharedColors.black};
  text-transform: capitalize;

  &:focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`

const StyledMenuButton = styled(Button)`
  padding: 0 !important;
  height: 100%;
  min-width: 0;
  :hover {
    background-color: transparent;
  }

  &:focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`
const ActualText = styled.span<{ isBold: boolean }>`
  font-weight: ${(props) => (props.isBold ? 500 : 400)};
  white-space: nowrap;
  position: absolute;
  top: 0;
  left: 0;
`

const ReservedTypographyWrapper = styled.span`
  position: relative;
  display: inline-block;
`
const HiddenBoldText = styled.span`
  font-weight: 500;
  visibility: hidden;
  white-space: nowrap;
`

interface ReservedTypographyProps {
  isBold: boolean
  children: React.ReactNode
}

function ReservedTypography({ isBold, children }: ReservedTypographyProps) {
  return (
    <ReservedTypographyWrapper>
      <HiddenBoldText>{children}</HiddenBoldText>
      <ActualText isBold={isBold}>{children}</ActualText>
    </ReservedTypographyWrapper>
  )
}

export default function NavLink({ data }: { data: MenuItemData }) {
  const [isOpen, setIsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isCategory = data.items?.length > 0
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsOpen(true)
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setIsOpen(false)
    setAnchorEl(null)
  }
  return (
    <>
      {isCategory ? (
        <StyledMenuButton
          variant="text"
          disableRipple
          onClick={handleClick}
          aria-controls={isOpen ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={isOpen ? "true" : undefined}
        >
          <ButtonInner isOpen={isOpen}>
            <ReservedTypography isBold={isOpen}>
              {data.label}
            </ReservedTypography>
            {isOpen ? <ArrowUp /> : <ArrowDown />}
          </ButtonInner>
        </StyledMenuButton>
      ) : (
        <StyledLink
          href={
            data.href.length > 0
              ? getNonUmbracoUrl(data.href)
              : data.menuName.startsWith("http")
                ? data.menuName
                : `https://${data.menuName}`
          }
          target={data.href.length > 0 ? "_self" : "_blank"}
        >
          <Typography variant="body2">{data.label}</Typography>
        </StyledLink>
      )}

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {data.items.map((item) => (
          <MenuItem
            key={item.label}
            onClick={() => {
              webMenuClick(item.label, data.label)
              handleClose()
            }}
          >
            <StyledLink
              href={`${getNonUmbracoUrl(item.href)}${item.href.includes("contact-us") || item.href.includes("payment-of-an-increased-rate-report") ? "?reset=true" : ""}`}
            >
              {item.label}
            </StyledLink>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
